export default __webpack_public_path__ + "static/media/IMG_0005 - Copy_12_11zon.67dc0119.jpg";